import styled, { css } from 'styled-components';

type SelectedType = {
  selected?: boolean;
};

export const MoreIcon = styled.span<SelectedType>`
  margin: 0;
  color: ${(props) => (props.selected ? '#288EFD' : '#656565')};
  font-size: 1.3rem;
`;

export const Divider = styled.div`
  width: 1px;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.1);
`;

type ContainerProps = {
  showTour: boolean;
};
export const Container = styled.header<ContainerProps>`
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 14px 24px;

  @media (max-width: 1100px) {
    display: none;
  }

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const BoxTwoBars = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContainerWrap = styled.div`
  position: relative;
`;

export const BoxNameAddress = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: 'Mangueira bold';
`;

export const BoxAddressBreadcrumb = styled.div`
  display: flex;
  flex-direction: row;
  flex-direction: column;
`;

export const Address = styled.div`
  font-size: 12px;
  color: #818181;
  text-transform: uppercase;
`;

export const Breadcrumb = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray};
  margin-top: 12px;
  margin-left: -16px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const TwoBars = styled.div`
  color: ${({ theme }) => theme.colors.blueClean};
  font-size: 16px;
  font-family: 'Mangueira bold';
  margin-right: 5px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const BoxNotificationProfile = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const IntroButton = styled.button`
  background: ${({ theme }) => theme.colors.mediumPurple};
  color: #ffffff;
  border: none;
  border-radius: 4px;
  height: 25px;
  font-size: 12px;
  font-weight: 600;
  transition: 0.5s;
  outline: none !important;
  span {
    margin-right: 4px;
  }
  &:hover {
    background: #328cfd;
  }
`;

export const BoxResponsiveMore = styled.div`
  display: none;
`;

export const ResponsiveGradient = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    align-items: center;
    padding: 10px 20px;
    border-radius: 5px;
    background: linear-gradient(#efefef, #ebebeb);
  }
`;

type TourBellWrapProps = {
  showTour?: boolean;
};

export const TourBellWrap = styled.div<TourBellWrapProps>`
  position: relative;

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
      background-color: #f5f5f5;
      padding: 2px 8px;
      border-radius: 8px;
    `}
`;
